/* Sinneszauber Duftnoten-Dynamik
   Liest "Kopfnote: ... Herznote: ... Basisnote: ..." aus Produkttexten und
   laesst echte Fotos der Zutaten um das Produktbild schweben.
   Fotos: assets/note-<schluessel>.jpg (Chogan & Wikimedia Commons, siehe Bildnachweise). */
(function () {
  // Reihenfolge zaehlt: Blueten vor Fruechten, Spezielles vor Allgemeinem.
  const RULES = [
    // Sonderf\u00e4lle zuerst (eigene Fotos oder passende Verwandte)
    [/champagner|sekt|prosecco/, 'sektglas'],
    [/pfirsichbl\u00fcte|kirschbl\u00fcte|apfelbl\u00fcte/, 'pfingstrose'],
    [/\brum\b|cognac|liquor|lik\u00f6r|brandy|whisk/, 'cognac'],
    [/narzisse|reseda|kamille/, 'jasmin'], [/ringelblume/, 'osmanthus'], [/glockenblume/, 'veilchen'],
    [/pelargonie/, 'geranie'], [/coconut/, 'kokos'], [/myrte/, 'rosmarin'], [/lorbeer/, 'salbei'],
    [/zypresse|kiefer|pinie|tanne/, 'zeder'], [/piment/, 'pfeffer'],
    [/candied fruits|kandierte fr\u00fcchte/, 'aprikose'], [/lacton/, 'moschus'], [/algae|\balge/, 'meer'],
    [/papyrus/, 'vetiver'], [/bambus/, 'tee'], [/barley|gerste|\bbran\b|kleie/, 'koriander'],
    [/\bflint|smoke|rauch(?!er)/, 'weihrauch'], [/tr\u00fcffel/, 'patschuli'], [/maninka/, 'sandelholz'], [/quandong/, 'pfirsich'],
    [/orangenbl\u00fcte|neroli|petitgrain|orangenbaum/, 'orangenbluete'],
    [/ylang|mimose/, 'ylang'], [/osmanthus/, 'osmanthus'], [/tuberose/, 'tuberose'],
    [/gardenie|frangipani/, 'gardenie'], [/maigl\u00f6ckchen/, 'maigloeckchen'],
    [/magnolie/, 'magnolie'], [/freesie/, 'freesie'],
    [/lilie|lotus|seerose|amaryllis|orchidee/, 'lilie'],
    [/jasmin|wei\u00dfe bl\u00fcten|weisse bl\u00fcten|blumige|hagedorn|bl\u00fcte/, 'jasmin'],
    [/pfingstrose|pfirsichbl\u00fcte|kirschbl\u00fcte/, 'pfingstrose'],
    [/geranie/, 'geranie'],
    [/rose(?!nholz)/, 'rose'],
    [/veilchen(?!blatt)|alpenveilchen|flieder|glyzinie|hyazinthe/, 'veilchen'],
    [/heliotrop/, 'heliotrop'], [/iris/, 'iris'], [/lavendel|lavandin/, 'lavendel'],
    [/vanille/, 'vanille'], [/tonka|kumarin/, 'tonka'],
    [/kaffee|espresso|arabica/, 'kaffee'], [/kakao|schokolade/, 'kakao'],
    [/zimt|nelke|gew\u00fcrz/, 'zimt'], [/muskat/, 'muskat'], [/safran/, 'safran'],
    [/rosa pfeffer|ros\u00e9 pfeffer|pinker pfeffer/, 'rosapfeffer'], [/pfeffer/, 'pfeffer'],
    [/kardamom/, 'kardamom'], [/ingwer/, 'ingwer'],
    [/koriander|k\u00fcmmel/, 'koriander'], [/(^|[^a-zäöü])(stern)?anis/, 'anis'], [/lakritz|s\u00fc\u00dfholz/, 'lakritz'],
    [/grapefruit|pampelmuse/, 'grapefruit'], [/bergamotte/, 'bergamotte'],
    [/limette|yuzu/, 'limette'], [/zitrone|zitronat|zitrus/, 'zitrone'],
    [/mandarin|clementine|tangerine/, 'mandarine'],
    [/orange|pomeranze|campari/, 'orange'],
    [/johannisbeere|cassis/, 'johannisbeere'], [/himbeere/, 'himbeere'],
    [/brombeere|heidelbeere|blaubeere|maulbeere/, 'brombeere'], [/erdbeere/, 'erdbeere'],
    [/rote beeren|beeren|kirsche|granatapfel|rhabarber|fruchtige/, 'himbeere'],
    [/pfirsich|nektarine/, 'pfirsich'], [/aprikose|mango|passionsfrucht|papaya/, 'aprikose'],
    [/litschi|lychee/, 'litschi'], [/pflaume|feige|trockenfr\u00fcchte|dattel/, 'pflaume'],
    [/apfel/, 'apfel'], [/birne/, 'birne'], [/ananas/, 'ananas'],
    [/kokos/, 'kokos'], [/melone/, 'melone'],
    [/mandel|marzipan|pistazie/, 'mandel'], [/honig|bienenwachs/, 'honig'],
    [/karamell|zucker|toffee|praline|kandis/, 'karamell'],
    [/tee|matcha|mate/, 'tee'],
    [/vetiver|gr\u00e4ser|gras|heu/, 'vetiver'],
    [/eichenmoos|moos/, 'moos'],
    [/minze|gr\u00fcne noten|galban|blatt|efeu|davana/, 'minze'],
    [/basilikum/, 'basilikum'], [/salbei|beifu\u00df/, 'salbei'], [/rosmarin|thymian|wacholder/, 'rosmarin'],
    [/marine|aquatisch|calone|meersalz|meer|wasser|ozon/, 'meer'],
    [/leder|wildleder/, 'leder'], [/oud|adlerholz/, 'oud'],
    [/weihrauch|olibanum|myrrhe|elemi|opopanax/, 'weihrauch'],
    [/benzoe|balsam|styrax|ladan|labdanum|harz/, 'benzoe'],
    [/patschuli|patchouli/, 'patschuli'],
    [/ambra|amber(?!wood)|ambergris/, 'ambra'],
    [/guajak/, 'guajak'], [/zeder/, 'zeder'], [/sandel/, 'sandelholz'],
    [/holz|kaschmir|birke|mahagoni|nagarmotha|amberwood|georgywood|palo santo/, 'guajak'],
    [/moschus|cashmeran|ambroxan|aldehyd|serenolide|hedione|ambrofix|zibet|pudrig|milch/, 'moschus'],
  ];

  function keyFor(name) {
    const n = name.toLowerCase();
    for (const [re, key] of RULES) if (re.test(n)) return key;
    return null;
  }

  function parse(text) {
    if (!text) return [];
    const t = text.replace(/\s+/g, ' ');
    const out = [];
    const re = /(Kopfnote|Herznote|Basisnote)n?\s*:\s*(.*?)(?=(Kopfnote|Herznote|Basisnote)n?\s*:|$)/gi;
    let m;
    while ((m = re.exec(t))) {
      const level = m[1][0].toUpperCase() + m[1].slice(1).toLowerCase();
      m[2].split(/,|\sund\s|\s&\s/).forEach((raw) => {
        const name = raw.replace(/[.;]+$/, '').trim();
        if (name && name.length < 40) out.push({ level, name, key: keyFor(name) });
      });
    }
    return out;
  }

  const base = () => (window.SZ && SZ.noteBase) || 'notes/';
  function custom(name) {
    const lib = window.SZ_NOTE_IMAGES || {};
    const lower = name.toLowerCase();
    for (const k in lib) if (k && lower.includes(k)) return lib[k];
    return null;
  }
  function srcFor(note) {
    return custom(note.name) || (note.key ? base() + 'note-' + note.key + '.jpg' : null);
  }
  function render(note) {
    const src = srcFor(note);
    return src ? `<img src="${src}" alt="" loading="lazy" decoding="async">` : '';
  }

  function pick(notes, max) {
    const seen = new Set();
    const res = [];
    for (const n of notes) {
      const id = n.key || n.name;
      if (seen.has(id) || !srcFor(n)) continue;
      seen.add(id);
      res.push(n);
      if (res.length >= max) break;
    }
    return res;
  }

  // Positionen rund ums Foto: [left%, top%, Groesse%, Tiefe]
  const SPOTS = [
    [-7, 6, 26, 1.2], [78, 2, 22, 0.8], [80, 60, 26, 1.4],
    [-8, 62, 22, 0.9], [38, -9, 18, 0.6], [46, 84, 20, 1.1],
  ];

  function decorate(el) {
    if (el.dataset.szDone) return;
    el.dataset.szDone = '1';
    const chosen = pick(parse(el.dataset.notes || ''), Number(el.dataset.max || 3));
    if (!chosen.length) return;
    const layer = document.createElement('div');
    layer.className = 'sz-notes';
    chosen.forEach((n, i) => {
      const s = SPOTS[i % SPOTS.length];
      const d = document.createElement('span');
      d.className = 'sz-note';
      d.style.cssText = `--x:${s[0]}%;--y:${s[1]}%;--s:${s[2]}%;--z:${s[3]};--i:${i}`;
      d.title = n.name;
      d.innerHTML = render(n) + (el.dataset.labels ? `<em>${n.name}</em>` : '');
      layer.appendChild(d);
    });
    el.appendChild(layer);
    el.classList.add('has-notes');
  }

  function pyramid(el) {
    const notes = parse(el.dataset.notes || '');
    if (!notes.length) return;
    const groups = { Kopfnote: [], Herznote: [], Basisnote: [] };
    notes.forEach((n) => groups[n.level] && groups[n.level].push(n));
    // Jedes Foto nur einmal pro Duft: steht dasselbe Bild schon in der Pyramide, gibt es den neutralen Punkt (18.10.2026)
    const used = new Set();
    const art = (n) => {
      const src = srcFor(n);
      if (!src || used.has(src)) return '<i></i>';
      used.add(src);
      return render(n);
    };
    el.innerHTML = Object.entries(groups).filter(([, v]) => v.length).map(([lvl, list]) =>
      `<div class="sz-pyr-row"><span class="sz-pyr-lvl">${lvl}</span><ul>${list.map((n) =>
        `<li><span class="sz-pyr-art">${art(n)}</span>${n.name}</li>`).join('')}</ul></div>`).join('');
    el.hidden = false;
  }

  function parallax(root) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.addEventListener('pointermove', (e) => {
      const r = root.getBoundingClientRect();
      root.style.setProperty('--px', ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
      root.style.setProperty('--py', ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
    });
    root.addEventListener('pointerleave', () => {
      root.style.setProperty('--px', 0);
      root.style.setProperty('--py', 0);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-notes]:not([data-pyramid])').forEach((el) => {
      decorate(el);
      if (el.dataset.parallax !== undefined) parallax(el);
    });
    (scope || document).querySelectorAll('[data-pyramid]').forEach(pyramid);
  }

  window.SZNotes = { init, parse, keyFor, render };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
